import React, { useContext, useEffect  } from 'react';
import { Link } from 'react-router-dom';
import {  Row, Col } from 'react-flexbox-grid';
import { Card, Form, Icon, Image, Message, Divider } from 'semantic-ui-react';
import Logo from '../../images/logo-admin.png';
import { Text, Translate, LanguageContext } from '../../helpers/language';
import { NotificationManager } from 'react-notifications';
import { backendService } from '../../services/backendService';


const RegistrationCompletePanel = (props) => {  

  const languageContext = useContext(LanguageContext);

  const { email, 
    signup_warning_message 
  } = props

  useEffect(() => {

    window.dataLayer.push({
      event: 'user_event',
      eventProps: {
        category: 'user_action',
        action: 'registration_completed',
        label: 'Registration Completed',
        value: 'true'
    }
    });

    window.dataLayer.push({
      event: 'page_view',
      page: {
        url: document.location.pathname,
        title: 'Registration Completed'
      }
    });   
  }, [])

  const sendNewVerification = (event) => {
    event.preventDefault()   
    backendService.post('/api/lawyers/verificationEmail', { email }).then( response => {
      if (response) {
        NotificationManager.success(Translate(languageContext, 'new_verification_email_sent'))
      } else {
        NotificationManager.success(Translate(languageContext, 'verification_email_failed'))
      }
    }, e => {
      NotificationManager.error(Translate(languageContext, 'verification_email_failed'))
    });
    
  }
    
  return (
    <div className="lisia-dialog lisia-centered-dialog">
      <Row center="xs">
        <Col className='registration-confirm-wrapper' xs={11} sm={6} md={4}>
          <Card fluid={true} raised={true} centered={true}>
            <Card.Content>
              <div className="registrationConfirmForm">
                <Image size='small' src={ Logo } className='m-b-10'/>
                <Form >
                  <h3 className='text-center'><Text tid='signup_success_panel_title' /></h3>         
                  <Divider />                      
                  <div className='signup_success_panel_body'>
                    {Translate(languageContext, 'signup_success_panel_body').replace(/\${email}/, email)}                  
                  </div>
                  <br></br>
                  <div className='signup_success_alert_body'>
                    {Translate(languageContext, 'signup_success_alert_body')}                  
                  </div>     
                  {
                    signup_warning_message && 
                    <>
                      <Divider /> 
                      <div className='signup_success_warning_body'>
                        {signup_warning_message}
                      </div>      
                    </>
                  }                               
                  <Divider />    
                  <div className='footer'>                   
                    <div style={{float: 'left'}}>
                    </div>
                    <Link onClick={sendNewVerification} style={{float: 'right'}}>
                      <Text tid="no_email_received" />
                    </Link>                 
                  </div>            
                </Form>
              </div>
            </Card.Content>
          </Card>
        </Col>
      </Row>
    </div>
  )  
}

export default RegistrationCompletePanel
